import React from 'react';
import { Box, Typography, IconButton } from '@mui/material';
import QrCode2OutlinedIcon from '@mui/icons-material/QrCode2Outlined';

const CardList = ({ cards, onCardClick }) => {
    return (
        <Box
            sx={{
                border: '1px solid #E0E0E0',
                borderRadius: '12px',
                marginTop: '16px',
                overflow: 'hidden',
            }}
        >
            {cards.map((card, index) => (
                <Box
                    key={card.id}
                    onClick={() => onCardClick?.(card)}
                    sx={{
                        display: 'flex',
                        flexDirection: 'column',
                        p: 2,
                        cursor: 'pointer',
                        borderBottom:
                            index !== cards.length - 1
                                ? '1px solid #E0E0E0'
                                : 'none',
                        '&:hover': {
                            backgroundColor: '#f9f9f9',
                        },
                    }}
                >
                    <Box display="flex" justifyContent="space-between">
                        <Box>
                            <Typography
                                sx={{
                                    fontFamily: 'Poppins',
                                    fontSize: '14px',
                                    fontWeight: 500,
                                    color: '#292929',
                                }}
                            >
                                Código: {card.id}
                            </Typography>

                            {card.user ? (
                                <Typography
                                    sx={{
                                        fontFamily: 'Poppins',
                                        fontSize: '13px',
                                        color: '#555',
                                    }}
                                >
                                    {card.user.name} ({card.user.nickname})
                                </Typography>
                            ) : (
                                <Typography
                                    sx={{
                                        fontFamily: 'Poppins',
                                        fontSize: '13px',
                                        color: 'gray',
                                    }}
                                >
                                    Não atribuído
                                </Typography>
                            )}

                            <Typography
                                sx={{
                                    fontFamily: 'Poppins',
                                    fontSize: '12px',
                                    fontWeight: '400',
                                    color: '#666666',
                                    mt: 1,
                                }}
                            >
                                Status: {card.status}
                            </Typography>
                        </Box>

                        <IconButton
                            onClick={(e) => {
                                e.stopPropagation();
                            }}
                        >
                            <QrCode2OutlinedIcon
                                sx={{ color: '#1F83FF !important' }}
                            />
                        </IconButton>
                    </Box>
                </Box>
            ))}
        </Box>
    );
};

export default CardList;
